/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Financial_Explorer_TabInputs */

const en_financial_explorer_tab = /** @type {(inputs: Financial_Explorer_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financial explorer`)
};

const nl_financial_explorer_tab = /** @type {(inputs: Financial_Explorer_TabInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Financiële explorer`)
};

/**
* | output |
* | --- |
* | "Financial explorer" |
*
* @param {Financial_Explorer_TabInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const financial_explorer_tab = /** @type {((inputs?: Financial_Explorer_TabInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Financial_Explorer_TabInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_financial_explorer_tab(inputs)
	return en_financial_explorer_tab(inputs)
});